<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="6" cols="7">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header">
                                <h3>Change Password</h3>
                            </div>
                            <b-row>
                                <b-col md="12">
                                      <base-input group :label="'Current ' + language_terms['PASSWORD']">
                                        <div class="input-group">
                                            <input :type="pwd_box_type" class="form-control" v-model="user.password1">
                                            <div class="input-group-append" id="button-addon4">
                                                <button class="btn btn-outline-success" type="button" @click="togglePwdBoxType"><i class="fa fa-eye"></i></button>
                                            </div>
                                        </div>
                                    </base-input>
                                </b-col>
                                <b-col md="12">
                                      <base-input group :label="'New ' + language_terms['PASSWORD']">
                                        <div class="input-group">
                                            <input :type="pwd_box_type" class="form-control" v-model="user.password2">
                                            <div class="input-group-append" id="button-addon4">
                                                <button class="btn btn-outline-success" type="button" @click="togglePwdBoxType"><i class="fa fa-eye"></i></button>
                                            </div>
                                        </div>
                                    </base-input>
                                </b-col>
                                <b-col md="12">
                                      <base-input group :label="'Confirm ' + language_terms['PASSWORD']">
                                        <div class="input-group">
                                            <input :type="pwd_box_type" class="form-control" v-model="user.password3">
                                            <div class="input-group-append" id="button-addon4">
                                                <button class="btn btn-outline-success" type="button" @click="togglePwdBoxType"><i class="fa fa-eye"></i></button>
                                            </div>
                                        </div>
                                    </base-input>
                                </b-col>

                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <b-button class="transparent-btn"  @click="savePassword" v-if="!isShowBtn">
                            <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['CHANGE_PASSWORD']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="saveUser" v-if="isShowBtn">
                            <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancelUser" v-if="isShowBtn">
                            <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Vue from 'vue'

import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import employeeLookup from "@/components/Autocomplete.vue";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

export default {
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            roles: state => state.users.roles,
            user_data:state => state.users.data,
            is_updated:state => state.users.is_updated,
            is_created:state => state.users.is_created,
            user_filter: state => state.users.filter,
            all_locations: state => state.locations.all_locations
        })
    },
    components: {
        Loading,
        employeeLookup
    },
    data(){
        return{
            loading:false,
            isShowBtn:false,
            title:"",
            pwd_box_type:"password",
            apiEmployeeLookup: apiRoutes["EMPLOYEE_LOOKUP"],
            user:{
                password1:"",
                password2:"",
                password3:"",
            }
        }
    },
    methods:
    {
        togglePwdBoxType()
        {
            if(this.pwd_box_type == 'text')
            {
                this.pwd_box_type = 'password';
            }
            else
            {
                this.pwd_box_type = 'text'
            }
        },
        savePassword()
        {
            axios.post(apiRoutes['USERS_CHANGE_PASSWORD'], this.user, authHeader())
            .then(response => {
            if(response.data.code == 1)
            {
                Vue.notify({group: 'notify', type: 'success', text: response.data.msg, max: 5, duration: 5000, speed: 300})
            } else 
            {
                Vue.notify({group: 'notify', type: 'error', text: response.data.msg, max: 5, duration: 5000, speed: 300})
            }
            })
            .catch(error => {
            if (error.response) {
                Vue.notify({group: 'notify', type: 'error', text: error.response.data.msg, max: 5, duration: 5000, speed: 300})
            }
        });
            

        },
        routeToMaster()
        {
            this.$router.push("/users/master");
        },
        cancelUser()
        {
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/users/master")
            }
            else
            {
                location.reload();
            }
        },
        async listRoles()
        {
            await this.$store.dispatch("users/fetchRoles", {})
        },
        async retrieveUser(handle)
        {
            await this.$store.dispatch("users/fetch", {handle: handle})
            this.user = this.user_data
        }
    },
    async mounted()
    {
        this.isShowBtn = false
    }
}
</script>
